module.exports = __webpack_public_path__ + "static/media/card_image_3.13a1e191.jpg";